/**
 * Utility functions for object operations
 */

/**
 * Checks if an object is empty (has no own enumerable properties)
 * @param {any} obj - The object to check
 * @returns {boolean} - True if the object is empty, false otherwise
 */
export const isEmpty = (obj) => {
    // Handle null, undefined, or non-objects
    if (!obj || typeof obj !== 'object') {
        return true;
    }

    // Check if object has any own enumerable properties
    return Object.keys(obj).length === 0;
};

/**
 * Checks if an object has content (has at least one own enumerable property)
 * @param {any} obj - The object to check
 * @returns {boolean} - True if the object has content, false otherwise
 */
export const hasContent = (obj) => !isEmpty(obj);
